import React from "react";
import { graphql, Link } from "gatsby";
import Layout from "../components/layout";

export default function Blog ({data}) {
    const { markdownRemark } = data;
    const { frontmatter, html } = markdownRemark;

    return (
        <Layout>
            <div className="blog-page">
                <Link to={'/blogs/'}>Blogs </Link><span>\ {frontmatter.title}</span>
                <h1>{frontmatter.title}</h1>
                <p className="blog-page__published-date">{frontmatter.date}</p>
                <div className="blog-post-content" dangerouslySetInnerHTML={{ __html: html }} />
            </div>
        </Layout>
    )
}

export const pageQuery = graphql`
    query($slug: String) {
        markdownRemark(frontmatter: { slug: { eq: $slug } }) {
            html
            frontmatter {
                date(formatString: "DD MMMM YYYY")
                slug
                title
            }
        }
    }
`;